import React, { useState } from 'react';
import HoverMessage from 'common/components/HoverMessage';
import { exitAllAndNoNewPositionsToday } from 'common/api/run';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';
import ModalComponentNew from 'v3/common/components/ModalComponentNew';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const DaySquareOffContent = () => (
  <>
    <p>
      Enabling <b>Day Square Off</b> will:
    </p>
    <ul className='pl-3'>
      <li>
        <b>Immediately close all open positions</b> for all strategies.
      </li>
      <li>
        Pause active strategies <b>without open positions</b>—they will not receive new signals for the rest of the day.
      </li>
      <li>
        Day squared-off strategies will <b>remain inactive</b> for the day unless manually restarted.
      </li>
      <li>
        All strategies will <b>automatically receive signals</b> for the next trading day.
      </li>
    </ul>
  </>
);

type RecentTransactionsProps = {
  totalRuns: number;
  daySquareOffCount: number;
};

const RecentTransactions: React.FC<RecentTransactionsProps> = ({ totalRuns, daySquareOffCount }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [shouldShowModal, setShouldShowModal] = useState(false);

  const noNewPositionsForToday = totalRuns > 0 && daySquareOffCount === totalRuns;

  const handleDaySquareOff = async () => {
    if (isProcessing) return;
    setIsProcessing(true);
    try {
      await exitAllAndNoNewPositionsToday();
      reactToastify('Squared Off All For Today Completed successfully', TOASTIFY_TYPES.SUCCESS);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        reactToastify(`Failed: ${error.message || 'Something went wrong, please try again'}`, TOASTIFY_TYPES.ERROR);
      } else {
        console.error('error', error);
        reactToastify('Failed: Something went wrong, please try again', TOASTIFY_TYPES.ERROR);
      }
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <div className="recent-transactions mb-2">
        <div className="recent-transactions__header mb-2">
          <h4>Recent Transactions</h4>
        </div>

        {!ApplicationDomainUtility.isCrypto && (<div className="recent-transactions__squared-off-all mb-2">
          <div className="d-flex align-items-center">
            <HoverMessage
              title="Day Square Off"
              message={<DaySquareOffContent />}
              popClassName="custom-popover"
              placement="bottom"
            >
              <span className="material-icons-outlined info-icon ml-1 mr-1">
                info
              </span>
            </HoverMessage>

            <button
              type="button"
              onClick={() => setShouldShowModal(true)}
              className="square-off-btn btn-sm d-flex"
              disabled={noNewPositionsForToday || isProcessing}
            >
              <i className="material-icons-outlined tx-18 mr-1">exit_to_app</i>
              Day Square Off
            </button>
          </div>
        </div>)}
      </div>

      <ModalComponentNew
        isOpen={shouldShowModal}
        onClose={() => setShouldShowModal(false)}
        onSave={() => { setShouldShowModal(false); handleDaySquareOff(); }}
        onCancel={() => setShouldShowModal(false)}
        okBtnTitle="Yes"
        cancelBtnTitle="No"
        renderTitle="Day Square Off Confirmation"
        renderBodyComponent={
          <div className="recent-transactions__modal-content">
            <DaySquareOffContent />
          </div>
        }
      />
    </>
  );
};

export default RecentTransactions;
